import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["refundCheckbox", "refundData"]

  connect() {
    this.update()
  }

  toggle() {
    this.update()
  }

  update() {
    const checked = this.refundCheckboxTarget?.checked
    if (!this.hasRefundDataTarget) return
    this.refundDataTarget.style.display = checked ? "" : "none"
    if (checked) this.fillToday()
  }

  fillToday() {
    const now = new Date()
    const selects = this.refundDataTarget.querySelectorAll("select")
    if (selects[0]) selects[0].value = now.getFullYear().toString()
    if (selects[1]) selects[1].value = (now.getMonth() + 1).toString()
    if (selects[2]) selects[2].value = now.getDate().toString()
  }
}
